import { createFileRoute } from '@tanstack/react-router';
import LoginPage from '@features/auth/login.tsx';

type LoginSearch = {
  redirectUrl?: string;
};

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirectUrl: typeof search.redirectUrl === 'string' ? search.redirectUrl : undefined,
  }),
  component: LoginPage,
});
